/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AcceptInvitationCommand } from "../models/AcceptInvitationCommand"
import type { AcceptLineLinkCommand } from "../models/AcceptLineLinkCommand"
import type { ConfirmInvitationCommand } from "../models/ConfirmInvitationCommand"
import type { GenerateCompanyInvitationCodeRequest } from "../models/GenerateCompanyInvitationCodeRequest"
import type { PendingInvitation } from "../models/PendingInvitation"
import type { User } from "../models/User"

import type { CancelablePromise } from "../core/CancelablePromise"
import { OpenAPI } from "../core/OpenAPI"
import { request as __request } from "../core/request"

export class InvitationService {
  /**
   * Generate invitation code used for LINE invitation
   * @param companyId
   * @param requestBody
   * @param xAccessToken
   * @returns any successful operation
   * @throws ApiError
   */
  public static encodeCompanyInvitationCode(
    companyId: number,
    requestBody: GenerateCompanyInvitationCodeRequest,
    xAccessToken?: string
  ): CancelablePromise<{
    invitationCode: string
  }> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/company/{companyId}/invitation/encode",
      path: {
        companyId: companyId,
      },
      headers: {
        "x-access-token": xAccessToken,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `No Permission`,
        500: `Internal Server Error`,
      },
    })
  }

  /**
   * Decode invitation code and resolve current LIST migration URL
   * @param companyId
   * @param requestBody
   * @returns any successful operation
   * @throws ApiError
   */
  public static decodeCompanyInvitationCode(
    companyId: number,
    requestBody: {
      invitationCode: string
    }
  ): CancelablePromise<{
    companyName?: string
    tagNames?: string[]
    listMigrationUrl?: string
  }> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/company/{companyId}/invitation/decode",
      path: {
        companyId: companyId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        500: `Internal Server Error`,
      },
    })
  }

  /**
   * Generate LINE account link code used for LINE invitation
   * @param xAccessToken
   * @returns any successful operation
   * @throws ApiError
   */
  public static encodeLineLinkCode(xAccessToken?: string): CancelablePromise<{
    linkCode: string
  }> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user/line_link/encode",
      headers: {
        "x-access-token": xAccessToken,
      },
      errors: {
        401: `Unauthorized`,
        500: `Internal Server Error`,
      },
    })
  }

  /**
   * Link LINE account to user from LINE app
   * @param requestBody
   * @returns any successful operation
   * @throws ApiError
   */
  public static linkLineAccount(requestBody: AcceptLineLinkCommand): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user/line_link/accept",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `No Permission`,
        500: `Internal Server Error`,
      },
    })
  }

  /**
   * List Pending Invitations
   * @param xAccessToken
   * @param companyId
   * @returns PendingInvitation successful operation
   * @throws ApiError
   */
  public static listPendingInvitations(
    xAccessToken: string,
    companyId: number
  ): CancelablePromise<Array<PendingInvitation>> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/company/{companyId}/user/pending_invitations",
      path: {
        companyId: companyId,
      },
      headers: {
        "x-access-token": xAccessToken,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `No Permission`,
        500: `Internal Server Error`,
      },
    })
  }

  /**
   * Confirm Invitation and Create User
   * @param companyId
   * @param invitationId
   * @param requestBody
   * @param xAccessToken
   * @returns User successful operation
   * @throws ApiError
   */
  public static confirmInvitation(
    companyId: number,
    invitationId: number,
    requestBody: ConfirmInvitationCommand,
    xAccessToken?: string
  ): CancelablePromise<User> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/company/{companyId}/user/pending_invitations/{invitationId}/confirm",
      path: {
        companyId: companyId,
        invitationId: invitationId,
      },
      headers: {
        "x-access-token": xAccessToken,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `No Permission`,
        500: `Internal Server Error`,
      },
    })
  }

  /**
   * Accept Invitation from LINE app
   * @param companyId
   * @param requestBody
   * @returns User successful operation
   * @throws ApiError
   */
  public static acceptInvitation(
    companyId: number,
    requestBody: AcceptInvitationCommand
  ): CancelablePromise<User> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/company/{companyId}/user/accept_invitation",
      path: {
        companyId: companyId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `No Permission`,
        500: `Internal Server Error`,
      },
    })
  }
}
